import type { ClientLocationConfirmationSource } from './types';

export { LOCATION_ATTESTATION_TEXT, LOCATION_ATTESTATION_VERSION } from '@unify/fhir-model/resources/client-location-confirmation';

export const CLIENT_LOCATION_SOURCE_LABELS: Record<ClientLocationConfirmationSource, string> = {
  device_location_prefilled_client_attested: 'Device location prefill + client attestation',
  ip_prefilled_client_attested: 'IP prefill + client attestation',
  manual_client_attested: 'Manual entry + client attestation',
  saved_address_client_attested: 'Saved address + client attestation',
};
